let toasts = new function() {
	this.show = (text, time) => {
		window.showToast(text, time);
		console.log({ text: text, position: 'top' });
	};
}();
export default toasts;



// WEBPACK FOOTER //
// ./src/utils/toasts.js